(() => {
  const reduceMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (!root || root.__faqInit) return;
    root.__faqInit = true;
    root.querySelectorAll('[data-faq-item]').forEach((item) => {
      const button = item.querySelector('.faq__question');
      if (!button || button.dataset.faqBound) return;
      button.dataset.faqBound = 'true';
      button.addEventListener('click', () => toggle(item, button));
    });
  };

  const toggle = (item, button) => {
    const answer = item.querySelector('.faq__answer');
    const isOpen = item.classList.contains('is-open');
    if (isOpen) {
      close(item, button, answer);
    } else {
      open(item, button, answer);
    }
  };

  const open = (item, button, answer) => {
    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.hidden = false;
    if (reduceMotion()) return;
    answer.style.maxHeight = answer.scrollHeight + 'px';
    window.setTimeout(() => {
      answer.style.maxHeight = '';
    }, 300);
  };

  const close = (item, button, answer) => {
    if (!reduceMotion()) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
      });
      window.setTimeout(() => {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        answer.hidden = true;
        answer.style.maxHeight = '';
      }, 300);
    } else {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
    }
  };

  window.GoldMathFAQ = { init };

  if (!customElements.get('goldmath-faq')) {
    customElements.define(
      'goldmath-faq',
      class GoldMathFAQ extends HTMLElement {
        connectedCallback() {
          init(this);
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq]').forEach(init);
  });
})();
